export default function(){
    return [
        { name: "Window", id: 1 },
        { name: "Door", id: 2 },
        { name: "Conservatory", id: 4 },
        { name: "Additional", id: 5 }
    ];
}


// WEBPACK FOOTER //
// ./src/reducers/itemType_reducer.js